const pluralRules = new Intl.PluralRules('ru-RU');

const LABELS: Partial<Record<Intl.LDMLPluralRule, string>> = {
  one: 'кандидат',
  few: 'кандидата',
  many: 'кандидатов',
};

export const getCandidateCountLabel = (count: number) => {
  return LABELS[pluralRules.select(count)] ?? 'кандидата';
};
